import { gql, TypedDocumentNode } from "@apollo/client";

import { AzureIntegration, Space } from "types/generated";

type AttachedStack = Pick<
  AzureIntegration["attachedStacks"][number],
  "id" | "stackId" | "stackName" | "isModule" | "isAutoattached"
> & {
  spaceDetails: Pick<Space, "id" | "name">;
};

export type AzureIntegrationView = Pick<
  AzureIntegration,
  | "adminConsentProvided"
  | "adminConsentURL"
  | "applicationId"
  | "updatedAt"
  | "displayName"
  | "id"
  | "labels"
  | "name"
  | "tenantId"
  | "servicePrincipalObjectId"
  | "defaultSubscriptionId"
  | "autoattachEnabled"
  | "spaceDetails"
  | "hasAttachedStacks"
> & {
  spaceDetails: Pick<AzureIntegration["spaceDetails"], "id" | "name" | "accessLevel">;
  attachedStacks: AttachedStack[];
};

type GetAzureIntegrationData = {
  azureIntegration?: AzureIntegrationView;
};

export const GET_AZURE_INTEGRATION: TypedDocumentNode<GetAzureIntegrationData> = gql`
  query GetAzureIntegration($id: ID!) {
    azureIntegration(id: $id) {
      adminConsentProvided
      adminConsentURL
      applicationId
      updatedAt
      displayName
      id
      labels
      name
      tenantId
      servicePrincipalObjectId
      defaultSubscriptionId
      autoattachEnabled
      spaceDetails {
        id
        name
        accessLevel
      }
      hasAttachedStacks
      attachedStacks {
        id
        stackId
        stackName
        isModule
        isAutoattached
        spaceDetails {
          id
          name
        }
      }
    }
  }
`;
